import { AnimatePresence, motion } from "motion/react";
import { FC, MouseEventHandler, PropsWithChildren, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { Address, isThor } from "rujira.js";
import { Icons, NetworkIcon, Provider, useClickOutside } from "rujira.ui";
//import { Merge } from "./components/Merge";
import clsx from "clsx";
import combined from "rujira.ui/src/assets/images/combined.gif";
import { ProviderIcon } from "../../common/components/Header";
import { useAccounts } from "../../services/accounts";

export const AccountSelect: FC = () => {
  const [showSwitch, setShowSwitch] = useState(false);
  const { accounts, selected, select } = useAccounts();
  const ref = useClickOutside(() => setShowSwitch(false));
  const loc = useLocation();
  const history = useNavigate();

  return (
    <div className="flex wrap ai-c">
      <a
        id="portfolio__switcher"
        className="portfolio__switcher"
        onClick={() => setShowSwitch(true)}>
        {selected ? (
          <>
            <NetworkIcon network={"THOR"} className="block w-2 h-2 mr-1" />

            {
              /* width > BreakPoints.large
              ? data?.address
              :  */ selected.address.substring(0, 12) +
                "..." +
                selected.address.slice(-12)
            }
          </>
        ) : (
          <>
            <div
              className="block w-2 h-2 mr-1 br-2 bg-primary2 color-white"
              style={{ padding: 2 }}>
              {/* <Combine className="block" /> */}
              <img
                src={combined}
                alt="combined"
                className="portfolio__switcher-all"
              />
            </div>
            Combined View (read only)
          </>
        )}
        <Icons.AngleDown className="w-2 h-2 ml-1" />

        <AnimatePresence>
          {showSwitch && (
            <motion.nav
              ref={ref}
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}>
              <>
                {accounts
                  ?.filter((x) => isThor(x.address))
                  .map((a) => (
                    <AccountItem
                      key={a.address + a.provider}
                      account={a}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSwitch(false);
                        loc.pathname !== "/portfolio" && history("/portfolio");
                        select(a);
                      }}
                    />
                  ))}
              </>
            </motion.nav>
          )}
        </AnimatePresence>
      </a>
      <div
        className={clsx({
          "div bg-black w-4 h-4 flex ai-c jc-c ml-1 color-grey br-3 transition":
            true,
          "bg-hover-darkGrey hover-white": selected,
        })}>
        <Icons.Copy
          className={clsx({ "w-2": true, "opacity-10": !selected })}
          onClick={() => {
            if (!selected) return;
            toast.success("Address copied to clipboard");
            navigator.clipboard.writeText(selected.address);
          }}
        />
      </div>
    </div>
  );
};

export const AccountItem: FC<
  PropsWithChildren<{
    account: { address: Address; provider: Provider.Key };
    onClick: MouseEventHandler<HTMLButtonElement>;
  }>
> = ({ account, onClick, children }) => {
  return (
    <button onClick={onClick}>
      <div className="flex ai-c w-full">
        <div className="flex">
          <NetworkIcon network={"THOR"} className="block w-3.5 h-3.5 mr-1" />
        </div>
        <div className="mr-2 flex dir-c ai-s">
          <span className="fs-12 color-white">
            {/* width > BreakPoints.large
              ? account.address
              : account.address.substring(0, 20) +
                "..." +
                account.address.slice(-20) */}
            {account.address.substring(0, 12) +
              "..." +
              account.address.slice(-12)}
          </span>
          <div
            className="fs-10 mt-0.5 flex ai-c"
            style={{ marginLeft: "-1rem" }}>
            <ProviderIcon
              provider={account.provider}
              className="block w-1.5 h-a mr-0.5"
              selected={true}
            />
            {account.provider}
          </div>
        </div>
        {children}
      </div>
    </button>
  );
};
